if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

//
// Compare lines height
// ------------------------------ 

$( document ).on('zg.compareProducts.getProductsInfo.complete', function() {
	$('.line.heading').each(function(index, elem) {
		if ( index == 0 ) return true;
		var height = 21;
		$('[data-zg-role="compare-products"] .contents .content .line:nth-of-type(' + (index + 1) + ')').each(function() {
			if ( $(this).height() > height ) height = $(this).height();
		});
		$('[data-zg-role="compare-products"] .content .line:nth-of-type(' + (index + 1) + ')').each(function() {
			$(this).height(height);
		});
	});
});

//
// PayPal Payment Issue Fix
// ------------------------------ 

$( document ).on( 'zg.selectPayment.paymentReady', function() {
	$('[data-zg-role="select-shipping-method"] input[name="shipping-method"]:checked').trigger('change.zg.selectSipping');
});

//
// Options hider
// ------------------------------

$(document).on('handlebars-rendered-product-options', function() {
	$('.option .product-filters:empty').each(function() {
		$(this).closest('.option').hide();
	});
	$('.option-dropdown .form-control').each(function() {
		if ( $('option', this).length == 1 ) $(this).closest('.option-dropdown').hide();
	});
});

$(document).on('filters.renderFilters', function() {
	$('.filter').each(function() {
		if ( $('.content-filter', this).is(':empty') ) $(this).hide();
	});
	$('.menu-dropdown .subsubmenu').each(function() {
		var that = this;
		if ( $('li', this).length > 10 && !$(this).hasClass('more') ) {
			$('li', this).each(function(index) {
				if ( index >= 10 ) $(this).hide();
			});
			$li = $('<li></li>');
			$a = $('<a>').attr('href','#').html('show more').addClass('morelink').appendTo($li).click(function(event) {
				event.preventDefault();
				if ( $(this).hasClass('morelink') ) {
					$('li', that).show();
					$(this).removeClass('morelink').addClass('lesslink').html('show less');
				} else {
					$('li', that).each(function(index) {
						if ( index >= 10 ) $(this).hide();
					});
					$(this).addClass('morelink').removeClass('lesslink').html('show more').parent().show();
				}
			});
			$li.appendTo($(this));
			$(this).addClass('more');
		}
	});
});

// add your site specific javascript here
(function ( $ ) {
	'use strict';

	//
	// Load lazy images
	// ------------------------------

	$('[href="#kaliedy-crew-reviews"]').click(function(){
		$(window).scroll();
	});

	//
	// eKomi Reviews show when loaded
	// ------------------------------

	function ekomiCheck() {
		var ekomiHtml = $('#reviews #widget-container').html();
		if (ekomiHtml) {
			var totalReviews = $('#reviews #widget-container .tot-reviews').html();
			if (totalReviews && parseInt(totalReviews) > 0) $('#reviews-heading').show();
		} 
		else setTimeout(ekomiCheck, 1000);
	};

	setTimeout(ekomiCheck, 1000);
	
	//
	// Validation
	// ------------------------------
	
	$.validator.addMethod("lettersonly", function(value, element) {
		return this.optional(element) || !(/[0-9]+/i.test(value));
	}, "Letters only please");
	
	$.validator.addMethod('eircode', function(value, element) {
  	var result;
  	if ( $(element).closest('form').find('[data-zg-role="country-id"]').val() == "99" ) {
    	result = (/(?:^[AC-FHKNPRTV-Y][0-9]{2}|D6W)[ -]?[0-9AC-FHKNPRTV-Y]{4}$/.test(value));
    } else {
    	result = true;
    }
  	return this.optional(element) || result;
  }, "Please enter correct Irish Eircode");
	
	$(document).on('shown.bs.modal', function(event) {
		$('[data-zg-validate="to-validate"]').zg_validate( window.ZG_CONFIG );
		$('#city[name="city"]').rules("add", { lettersonly: true });
		$('#post_code').rules("add", { eircode: true });
		$('#guestshipping_address_post_code').rules("add", { eircode: true });
		$('#registershipping_address_post_code').rules("add", { eircode: true });
	});
	$('[data-zg-validate="to-validate"]').zg_validate( window.ZG_CONFIG );
	$('#city[name="city"]').rules("add", { lettersonly: true });
	$('#post_code').rules("add", { eircode: true });
	$('#guestshipping_address_post_code').rules("add", { eircode: true });
	$('#registershipping_address_post_code').rules("add", { eircode: true });
	
	//
	// Currently selected option
	// ------------------------------
	
	$(document).on('zg.product.optionSelected', function(event, optionData) {
		$('[data-zg-role="product"][data-id="' + optionData.productId + '"] [data-zg-role="selected-value"][data-option-id="' + optionData.optionId + '"]').html(optionData.info.optionName);
		if ( optionData.gallery && optionData.gallery[0].medium ) $('.image [data-option-id="' + optionData.optionId + '"]').attr('src',optionData.gallery[0].small).show();
		else $('.image[data-option-id="' + optionData.productId + '"]').hide();
	});

	$.ajaxSetup( {
		cache: true
	} );

	//For crawler
	if ( !window.JS_ENABLED ) {
		$.ajax( {
			url:      window.makeUrl( { module: 'eshop', action: 'setJavascriptEnabled' } ),
			type:     'post',
			dataType: 'json'
		} );
	}

	// -----------------------------------------------------------------------------------------------------------------
	// Anything to be initialized on document ready goes here

	$( function () {
		
		//
		// Go to reviews
		// ------------------------------
		
		$('.video-play').click(function(event) {
			event.preventDefault();
			var id = $(this).attr('href');
			$('#zoomMain').hide();
			$(id).show();
		});
		
		//
		// Go to reviews
		// ------------------------------
		
		$('#go-to-reviews').click(function(event) {
			event.preventDefault();
			var goto = $('#reviews-link').offset().top;
			$("html, body").animate({ scrollTop: goto }, 300, 'swing');
			if ( $('#reviews-link').hasClass('collapsed') ) $('#reviews-link').click();
		});
		
		//
		// Modal
		// ------------------------------
		
		function genericPopupTimer(timeout, id) {
			var timeFromFirstVisit = Date.now() - $.cookie("generic-cookie-" + id);
			var shown = false;
			$('[data-zg-role="generic-modal"]').each(function() {
				if ($(this).hasClass('in')) shown = true;
			});
			if ( timeFromFirstVisit > timeout && document.location.pathname != '/eshop/register/' && shown == false ) {
				$.cookie("generic-cookie-" + id, 9999999999999, { path: '/' });
				if ( $("#generic_modal_" + id) ) $("#generic_modal_" + id).modal();
			} else {
				setTimeout(function() {
					genericPopupTimer(timeout-1000, id);
				}, 1000);
			}
		};
		
		$('[data-zg-role="generic-modal"]').each(function() {
			var id = $(this).data('id');
			var timeout = $(this).data('timeout');
			var firstVisit = $.cookie("generic-cookie-" + id);
			if ( !firstVisit ) {
				firstVisit = Date.now();
				$.cookie("generic-cookie-" + id, firstVisit, { path: '/' });
			}
			setTimeout(function() {
				genericPopupTimer(timeout, id);
			}, 1000);
		});
		
		//
		// Return to category at same place
		// ------------------------------
		
		if (window.ACTUAL_CATEGORY != 0) {
			var last_position = zgReadCookie('last_position');
			var last_category_id = zgReadCookie('last_category_id');
			
			$(window).on('zg.getProductInfo.productCreated', function() {
				if( lazyLoadInstance ){
					lazyLoadInstance.update();
					$('[data-zg-role="product-link"]').off().on('click', function(event) {
						var position = $(window).scrollTop();
						var category_id = window.ACTUAL_CATEGORY;
						zgCreateCookie('last_position', position, 1);
						zgCreateCookie('last_category_id', category_id, 1);
					});
				}
			});
		
			if ( last_position && last_category_id && last_category_id == window.ACTUAL_CATEGORY ) {
				if ( $('body').hasClass('category') ) {
					$('.loading-overlay').show();
					var move = true;
					
					$(window).on('zg.getProductInfo.productCreated', function() {
						if (move) {
							var goto = $(document).height();
							if (goto >= last_position) goto = last_position;
							$("html, body").delay(100).animate({ scrollTop: goto }, 100, 'swing', function() {
								var position = $(window).scrollTop();
								if (position >= last_position) {
									$('.loading-overlay').hide();
									zgEraseCookie('last_position');
									zgEraseCookie('last_category_id');
									move = false;
								}
							});
						}
					});
					
				} else {
					zgEraseCookie('last_position');
					zgEraseCookie('last_category_id');
				}
			}
		} else {
			zgEraseCookie('last_position');
			zgEraseCookie('last_category_id');
		}	
		
		//
		// Video autoplay
		// ------------------------------
		
		if ( document.getElementById('video-0') ) document.getElementById('video-0').play();
		
		$('a[href="#site_footer_newsletter"]').click(function(event){
			event.preventDefault();
			var top = $('#site_footer_newsletter').offset().top + $('#site_footer_newsletter').height() / 2 - $(window).height() / 2;
			$('html, body').animate({scrollTop: top}, 400);
		});
		
		//
		// Custom Fields Relations
		// ------------------------------
		
		$('[data-zg-role="custom-fields-father"]').each(function() {
			var that = this;
			var fatherValue = $(this).data('father-value');
			var father = $(this).data('father');
			var $father = $('#' + father);
			$father.change(function() {
				var value = $(this).val();
				if ( value >= fatherValue ) $(that).removeClass('hidden');
				else {
					$(that).val('');
					$(that).addClass('hidden');
				}
			}).change();
		});
		
		//
		// Datepicker
		// ------------------------------
		
		$( ".datepicker" ).datepicker({
			changeMonth: true,
      changeYear: true,
			yearRange: 'c-100:c+1',
			dateFormat: 'dd,mm,yy'
		});
		
		//
		// Address preview
		// ------------------------------
		
		function updateAddressPreview($preview, addr_1, addr_2, addr_3, city, country, state, post_code) {
			var html = "";
			if ( addr_1 ) html = html + addr_1;
			if ( addr_2 ) html = html + (html?"<br>":"") + addr_2;
			if ( addr_3 ) html = html + (html?"<br>":"") + addr_3;
			if ( city ) html = html + (html?"<br>":"") + city;
			if ( country ) html = html + (html?"<br>":"") + country;
			if ( state ) html = html + (html?"<br>":"") + state;
			if ( post_code ) html = html + (html?"<br>":"") + post_code;
			$preview.html(html);
		}
		
		//
		// Marketing Preferences Register
		// ------------------------------
		
		$('#accept_newsletter').change(function(event){
			if ( $(this).prop('checked') ) $('#marketing_preferences').show();
			else $('#marketing_preferences').hide();
		});
	
		//
		// Address manually
		// ------------------------------
		
		$('.address-manually-link').click(function(event){
			event.preventDefault();
			$(this).closest('form').find('.address-manually').removeClass('hidden');
			$(this).closest('form').find('.address-preview').hide();
			$(this).closest('form').find('.address-lookup').hide();
		});
		
		function stateFix($field, city) {
			if ( $field.val() == "" ) {
				var cityid = null;
				$field.find('option').each(function() {
					if ( city.match( $(this).text() ) ) cityid = $(this).val();
				});
				if ( cityid ) $field.val(cityid).focusout();
				else $('.address-manually-link').click();
			}
		}
		
		//
		// Loqate
		// ------------------------------
		
		if (window.pca) {
			$('[name="registersearch_by_address_country"], [name="guestsearch_by_address_country"], [name="search_by_address_country"]').prop('type', 'text').prop('autocomplete', 'pca-override');
			var shippingFields = [
				{ element: "registersearch_by_address_country", field: "CountryName", mode: pca.fieldMode.COUNTRY },
				{ element: "registersearch_by_address", field: "Line1" },
				{ element: "registersearch_by_post_code", field: "PostalCode" },
				{ element: "registershipping_address_addr_1", field: "Line1" },
				{ element: "registershipping_address_addr_2", field: "Line2", mode: pca.fieldMode.POPULATE },
				{ element: "registershipping_address_addr_3", field: "Line3", mode: pca.fieldMode.POPULATE },
				{ element: "registershipping_address_city", field: "City", mode: pca.fieldMode.POPULATE },
				{ element: "registershipping_address_state_id", field: "Province", mode: pca.fieldMode.POPULATE },
				{ element: "registershipping_address_post_code", field: "PostalCode" },
				{ element: "registershipping_address_country_id", field: "CountryName", mode: pca.fieldMode.COUNTRY }
			];
			var guestFields = [
				{ element: "guestsearch_by_address_country", field: "CountryName", mode: pca.fieldMode.COUNTRY },
				{ element: "guestsearch_by_address", field: "Line1" },
				{ element: "guestsearch_by_post_code", field: "PostalCode" },
				{ element: "guestshipping_address_addr_1", field: "Line1" },
				{ element: "guestshipping_address_addr_2", field: "Line2", mode: pca.fieldMode.POPULATE },
				{ element: "guestshipping_address_addr_3", field: "Line3", mode: pca.fieldMode.POPULATE },
				{ element: "guestshipping_address_city", field: "City", mode: pca.fieldMode.POPULATE },
				{ element: "guestshipping_address_state_id", field: "Province", mode: pca.fieldMode.POPULATE },
				{ element: "guestshipping_address_post_code", field: "PostalCode" },
				{ element: "guestshipping_address_country_id", field: "CountryName", mode: pca.fieldMode.COUNTRY }
			];
			var popupFields = [
				{ element: "search_by_address_country", field: "CountryName", mode: pca.fieldMode.COUNTRY },
				{ element: "search_by_address", field: "Line1" },
				{ element: "search_by_post_code", field: "PostalCode" },
				{ element: "addr_1", field: "Line1" },
				{ element: "addr_2", field: "Line2", mode: pca.fieldMode.POPULATE },
				{ element: "addr_3", field: "Line3", mode: pca.fieldMode.POPULATE },
				{ element: "city", field: "City", mode: pca.fieldMode.POPULATE },
				{ element: "state_id", field: "Province", mode: pca.fieldMode.POPULATE },
				{ element: "post_code", field: "PostalCode" },
				{ element: "country_id", field: "CountryName", mode: pca.fieldMode.COUNTRY }
			];
			var options = {key: "MR75-TM58-UM59-HT59", countries: { codesList:"IRL, GBR, AUT, BEL, BIH, BGR, HRV, CYP, CZE, DNK, EST, FIN, FRA, DEU, GRC, GGY, HUN, ISL, ITA, LVA, LIE, LTU, LUX, MLT, NLD, NOR, POL, PRT, ROU, SRB, SVK, SVN, ESP, SWE, CHE, USA"}, setCountryByIP: false};
			var shippingAddress = new pca.Address(shippingFields, options);
			var guestAddress = new pca.Address(guestFields, options);
			
			shippingAddress.listen("populate", function(address, variations) {
				for (var field in shippingFields) {
					$('#' + shippingFields[field].element).focusout();
				}
				stateFix( $('#registershipping_address_state_id'), address.City );
				updateAddressPreview($('.register-address-preview'), address.Line1, address.Line2, address.Line3, address.City, address.CountryName, address.Province, address.PostalCode );
			});
			
			guestAddress.listen("populate", function(address, variations) {
				for (var field in guestFields) {
					$('#' + guestFields[field].element).focusout();
				}
				stateFix( $('#guestshipping_address_state_id'), address.City );
				updateAddressPreview($('.guest-address-preview'), address.Line1, address.Line2, address.Line3, address.City, address.CountryName, address.Province, address.PostalCode );
			});

			$(document).on('zg.addressForm.ready', function(event, AddressById) {
				var popupAddress = new pca.Address(popupFields, options);
				
				popupAddress.listen("populate", function(address, variations) {
					for (var field in popupFields) {
						$('#' + popupFields[field].element).focusout();
					}
					stateFix( ('#state_id'), address.City );
					updateAddressPreview($('.address-preview'), address.Line1, address.Line2, address.Line3, address.City, address.CountryName, address.Province, address.PostalCode );
				});
			});
		}
		
		//
		// Find out more
		// ------------------------------
		
		$('.find-out-more').click(function(event){
			event.preventDefault();
			var $panel = $('a[href="#delivery-and-returns"]');
			if ( $panel.hasClass('collapsed') ) $panel.click();
			var top = $panel.offset().top;
			$('html, body').animate({scrollTop: top});
		});
		
		//
		// Update totals on checkout
		// ------------------------------
		
		$(document).on('zg.selectShipping.shippingReady',function(event, shippingId, shippingInfo) {
			var cost = shippingInfo.cost;
			if (shippingInfo.currency == 'EUR') cost = "€ " + cost;
			else if (shippingInfo.currency == 'USD') cost = "$ " + cost;
			else if (shippingInfo.currency == 'GBP') cost = "£ " + cost;
			$('.total-line.shipping .value').html(cost);
			var total = 0;
			$('.total-line:not(.ignore)').each(function(){
				var line = $('.value', this).html();
				var value = line.match(/[0-9]+\.[0-9]+/);
				if (value) total += parseFloat(value[0]);
			});
			total = Math.round(total*100)/100;
			if (shippingInfo.currency == 'EUR') total = "€ " + total;
			else if (shippingInfo.currency == 'USD') total = "$ " + total;
			else if (shippingInfo.currency == 'GBP') total = "£ " + total;
			$('.total-line.total .value').html(total);
		});
		
		//
		// Added to cart refresh page on cart page
		// ------------------------------
		
		if ( $('body').hasClass('cart') ) {
			$(document).on('zg.product.addedToCart', function() {
				location.reload();
			});
		}
		
		//
		// Added to cart refresh page on cart page
		// ------------------------------
		
		$('.compare-return').click(function(event) {
			event.preventDefault();
			window.history.back();
		});
		
		//
		// Create your own
		// ------------------------------
		
		$('.create-your-own .image-left').click(function(event) {
			event.preventDefault();
			$('.thumbnails a.active').parent().prev().find('a').click();
		});
		
		$('.create-your-own .image-right').click(function(event) {
			event.preventDefault();
			$('.thumbnails a.active').parent().next().find('a').click();
		});
		
		$('#tabs [data-zg-role="create-your-own-tab"]').click(function(event) {
			event.preventDefault();
			if ( !$(this).hasClass('disabled') ) {
				var href = $(this).attr('href');
				$('#tabs [data-zg-role="create-your-own-tab"]').addClass('collapsed');
				$(this).removeClass('collapsed');
				$('[data-zg-role="create-your-own"]').removeClass('in');
				$('[data-zg-role="create-your-own"]' + href).addClass('in');
			}
		});
		
		$(document).on('zg.getProductInfo.complete', function() {
			$('.image-option:not(.initialized):not(.disabled)').each(function() {
				$(this).addClass('initialized').click(function(event) {
					event.preventDefault();
					var total = 0;
					var summary = "";
					var banner = "";
					var id = $(this).data('id');
					var price = $(this).data('price');
					var quantity = $(this).closest('[data-zg-role="create-your-own"]').data('quantity');
					var next = $(this).closest('[data-zg-role="create-your-own"]').data('next');
					var last = $(this).closest('[data-zg-role="create-your-own"]').hasClass('last');
					var bundlePrice = $('[data-zg-role="create-your-own-banner"]').data('bundle-price');
					var imageMedium = $(this).data('image');
					var imageZoom = $(this).data('zoom');
					var parentId = $('.product-details').data('id');
					$('a[href="#tabs-' + next + '"]').removeClass('disabled');
					$(this).parent().siblings().find('a').removeClass('active');
					$(this).addClass('active');
					$(this).closest('[data-zg-role="create-your-own"]').find('.create-your-own-product[data-zg-role="product"]').addClass('hidden');
					$(this).closest('[data-zg-role="create-your-own"]').find('.create-your-own-product[data-zg-role="product"][data-id="' + id + '"]').removeClass('hidden');
					
					var $gallery = $('[data-zg-role="product"][data-id="' + parentId + '"] [data-zg-role="gallery"][data-is360="false"]');
					if (!$gallery.find('[data-zg-role="bundle-item-image"][data-id="' + id + '"]').length) {
						var $div = $('<div></div>').addClass('col-xs-3').addClass('col-md-2').addClass('col').attr('data-zg-role','bundle-item-image').attr('data-id',id);
						var $a = $('<a></a>').attr('href','#').attr('data-images', imageMedium).attr('data-zoom-images', imageZoom).attr('data-auto-zoom','true').attr('data-auto-play','false').click(function(event){event.preventDefault();$('#zoomMain').show();$('#video').hide();}).appendTo($div);
						$('<img/>').addClass('img-responsive').attr('src',imageMedium).attr('alt','Image ' + id).appendTo($a);
						$div.appendTo($gallery);
						$a.click();
					}
					if (quantity && quantity > 1) {
						$(this).closest('[data-zg-role="create-your-own"]').find('[data-zg-role="quantity"]').val(quantity);
						$(this).next().find('.q').html(' x ' + quantity);
						$(this).next().find('.p').html(parseInt(quantity) * parseFloat(price));
					}
					$('[data-zg-role="create-your-own"] .product-filters [data-zg-role="get-product"] a.active').each(function() {
						var qty = $(this).closest('[data-zg-role="create-your-own"]').data('quantity') || 1;
						total += $(this).data('price') * qty;
						summary += "<li>" + qty + " x " + $(this).data('name') + "</li>";
						banner += '<div class="image">' + $(this).html() + '</div>';
					});
					total = (Math.round(total*100)/100).toFixed(2);
					if (last && bundlePrice) {
						$('[data-zg-role="create-your-own-to-sell"]').html('<span>&euro;' + bundlePrice + '</span>&nbsp;<del>&euro;' + total + '</del>');
					} else {
						$('[data-zg-role="create-your-own-to-sell"]').html('&euro; ' + total);
					}
					if ( summary ) {
						$('[data-zg-role="create-your-own-summary-list"]').html(summary);
						$('[data-zg-role="create-your-own-summary"]').show();
					}
					if ( banner ) {
						$('[data-zg-role="create-your-own-banner-images"]').html(banner);
						$('[data-zg-role="create-your-own-banner"]').show();
					}
				});
			});
			
			$('.create-your-own-product:not(.initialized)').each(function() { 
				$(this).addClass('initialized').find('.btn-next-step').click(function(event) {
					event.preventDefault();
					var index = $(this).closest('[data-zg-role="create-your-own"]').data('next');
					$('#tabs .panel-heading a[href="#tabs-' + index + '"]').click();
				});
			});
			$('[data-zg-role="add-to-cart-create-your-own"]:not(.initialized)').each(function() {
				$(this).addClass('initialized').click(function(event) {
					event.preventDefault();
					$(this).html('adding to basket...').removeClass('btn-add').addClass('disabled');
					var $addToBasketButtons = $('.create-your-own-product:not(.hidden) [data-zg-role="add-to-cart"]:not(.disabled)');
					$addToBasketButtons.first().click().addClass('disabled');
				});
			});
		});

		if ( $('.product-details').hasClass('create-your-own') ) {
			$(document).on('zg.product.addedToCart', function(event, status, product, data) {
				var $addToBasketButtons = $('.create-your-own-product:not(.hidden) [data-zg-role="add-to-cart"]:not(.disabled)');
				if ($addToBasketButtons.length) {
					$addToBasketButtons.first().click().addClass('disabled');
				} else {
					$('[data-zg-role="add-to-cart-create-your-own"].disabled').removeClass('disabled').addClass('btn-add').html('add to basket');
				}
			});
		}

		setTimeout(function() {
			var open_next = true;
			$('[data-zg-role="create-your-own"]').each(function(event) {
				var $products = $('.product-option', this);
				var $next = $('.btn-next-step', this);
				if ( $products.length == 1 ) {
					$products.find('.image-option').click();
					if ( open_next ) $next.click();
				} else open_next = false;
			});
		}, 500);
		
		//
		// Shop by look
		// ------------------------------
		
		$(document).on('zg.getProductInfo.complete', function() {
			$('#shopbylookItems-variants .variant').off().click(function(event){
				event.preventDefault();
				var id = $(this).data('id');
				$('#shopbylookItems-variants .variant').removeClass('active').addClass('disabled');
				$(this).addClass('active').removeClass('disabled');
				$('#shopbylookItems-options .product-options, #shopbylookItems-gallery .product-gallery, #shopbylookItems-prices .product-price').addClass('hidden');
				$('#shopbylookItems-options .product-options[data-id="'+id+'"], #shopbylookItems-gallery .product-gallery[data-id="'+id+'"], #shopbylookItems-prices .product-price[data-id="'+id+'"]').removeClass('hidden');
				$('#shopbylookItems-gallery .product-gallery[data-id="'+id+'"] .col:first-child a').click();
			});
		});
		
		//
		// Gallery stop jumping
		// ------------------------------
		
		$('.thumbnails [data-zg-role="gallery"] a').click(function(event){
			event.preventDefault();
			$('#zoomMain').show();
			$('.video').hide();
		});
		
		//
		// Write a review
		// ------------------------------
		
		$('.write-a-review').click(function(event){
			event.preventDefault();
			var $panel = $('a[href="#reviews"]');
			if ( $panel.hasClass('collapsed') ) $panel.click();
			var top = $panel.offset().top;
			$('html, body').animate({scrollTop: top});
		});
		
		//
		// Sticky Menu
		// ------------------------------
		
		var headerMenuTop = 74;
	
		function sticky() {
			var top = $(window).scrollTop();
			var width = $(window).width();
			if ( width < 768 && top >= headerMenuTop ) $('#site_header, html').addClass('sticky');
			else $('#site_header, html').removeClass('sticky');
		}
		
		if ( !$('body').hasClass('checkout') ) {
			$(window).scroll(function(){
				sticky();
			});
			sticky();
		}
		
		//
		// Mobile menu toggle
		// ------------------------------
		
		$('.menu-dropdown .submenu .has-children a').hover(function(event){
			var id = $(this).data('id');
			var $subsubmenu = $('.menu-dropdown .subsubmenu[data-id="' + id + '"]');
			$(this).parent().siblings().find('a').removeClass('active');
			$(this).addClass('active');
			$subsubmenu.siblings().removeClass('active');
			$subsubmenu.addClass('active');
		}, function(event){
			// do nothing
		});
		
		//
		// Mobile menu toggle
		// ------------------------------
		
		$('.mobile-menu-toggle').click(function(event){
			event.preventDefault();
			$('html').toggleClass('mobile-menu-open');
		});
		
		//
		// Mobile menu accordion
		// ------------------------------
		
		$('#site_mobile_menu .menu .has-children > a').click(function(event){
			event.preventDefault();
			$(this).parent().siblings().removeClass('active');
			$(this).parent().toggleClass('active');
		});
		
		//
		// Header Menu Touch
		// ------------------------------
		
		$('.touchevents #site_header .menu > li.has-children > a').click(function(event){
			event.preventDefault();
			event.stopPropagation();
			var isActive = $(this).parent().hasClass('active');
			$(this).parent().siblings().removeClass('active');
			if ( isActive ) {
				$(this).parent().removeClass('active');
				$('#site_dropdown_overlay').hide();
			} else {
				$(this).parent().addClass('active');
				$('#site_dropdown_overlay').show();
			}
		});
		$('.no-touchevents #site_header .menu > li.has-children').hover(function(event){
			$('#site_dropdown_overlay').show();
		},function(event){
			$('#site_dropdown_overlay').hide();
		});
		$('.touchevents body').click(function(event){
			$('#site_header .menu > li.has-children').removeClass('active');
			$('#site_dropdown_overlay').hide();
		});
		
		//
		// Header Messages
		// ------------------------------
		
		$('#site_header_messages .messages').slick({
			dots: false,
			infinite: true,
			arrows: false,
			slidesToShow: 4,
			slidesToScroll: 1,
			prevArrow: '<button type="button" class="slick-arrow slick-arrow-prev"><i class="fa fa-chevron-left"></i><span class="sr-only">Previous</span></button>',
			nextArrow: '<button type="button" class="slick-arrow slick-arrow-next"><i class="fa fa-chevron-right"></i><span class="sr-only">Next</span></button>',
			responsive: [
				{
					breakpoint: 1470,
					settings: {
						arrows: true,
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
			]
		});
		
		//
		// Carousel Page Component
		// ------------------------------
		
		$('.component-carousel .carousel').on('init', function(event, slick){
			$(this).show().next('.component-slider-loading').hide();
		}).slick({
			lazyLoad: 'ondemand',
			dots: false,
			infinite: false,
			arrows: true,
			slidesToShow: 6,
			slidesToScroll: 6,
			autoplay: false,
			responsive: [
				{
					breakpoint: 1470,
					settings: {
						slidesToShow: 5,
						slidesToScroll: 5
					}
				},
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 4,
						slidesToScroll: 4
					}
				},
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3
					}
				}
			]
		});
		
		//
		// Slider Page Component
		// ------------------------------
		
		$('.component-slider').on('init', function(event, slick){
			$(this).show().next('.component-slider-loading').hide();
		}).slick({
			dots: true,
			infinite: true,
			arrows: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
  		autoplaySpeed: 8000
		});
		
		$('.component-slider').each(function() {
			var self = this;
			$('.slick-prev', this).click(function(event){
				event.preventDefault();
				$(self).slick('slickPrev');
			});
			$('.slick-next', this).click(function(event){
				event.preventDefault();
				$(self).slick('slickNext');
			});
		});
		
		//
		// Sorter
		// ------------------------------
		
		$('.tools-sorter ul').click(function(event){
			if ( !$(this).hasClass('active') ) {
				event.preventDefault();
				event.stopPropagation();
				$(this).addClass('active');
			}
		});
		$('body').click(function(event){
			$('.tools-sorter ul').removeClass('active');
		});
		
		//
		// Product ellipsis
		// ------------------------------
		
		//$(document).on('zg.getProductInfo.productCreated', function(e, element, options, product) {
			//$('p.name', element).dotdotdot({watch: true});
		//});

		//
		// Special Offers Carousel
		// ------------------------------
		
		$('.component-product-marketing .product-list').slick({
			dots: false,
			infinite: false,
			arrows: true,
			slidesToShow: 4,
			slidesToScroll: 4,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2
					}
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
			]
		});
		$(document).on('zg.product.ready',function(){
			setTimeout(function(){
				$('.component-product-marketing .product-list').slick('refresh');
			},100);
		});
		
		//
		// Blog carousel
		// ------------------------------
		
		$('.component-blog .slick').slick({
			dots: false,
			infinite: false,
			arrows: true,
			slidesToShow: 3,
			slidesToScroll: 3,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						arrows: false
					}
				}
			]
		});
		
		//
		// Other
		// ------------------------------
		
		//First modal registration
		$( '#registrationModalThanks' ).modal( 'show' );

		// If we have an "active" tab we start with that one selected, otherwise we select the first one
		$( '.nav-tabs' ).each( function () {
			var $activeTab = $( this ).find( '.active [data-toggle="tab"]:first' );

			if ( $activeTab.length ) {
				$activeTab.tab();
			} else {
				$( this ).find( '[data-toggle="tab"]:first' ).tab();
			}
		} );

		// ll Settings - Home
		$( '.carousel' ).carousel( {} );

        // SWIPE CAROUSEL
        var $carousel = $( '.carousel' );
        if ( $carousel.length ) {
            $carousel.swiperight( function () {
                $( this ).carousel( 'prev' );
            } );
            $carousel.swipeleft( function () {
                $( this ).carousel( 'next' );
            } );
        }
	} );

	$( function () {
		$( this ).find( '[data-zg-role="search-input"]').each( function(){
				//Bind the search function
				$( this ).on('input paste', function(){


					// Retrieve the input field text and reset the count to zero
					var filter = $(this).val(), count = 0;

					// Loop through the comment list
					$('[data-zg-role="search-items"]').each(function(){

						// If the list item does not contain the text phrase fade it out
						if ($(this).text().search(new RegExp(filter, "i")) < 0) {
							$(this).fadeOut();

							// Show the list item if the phrase matches and increase the count by 1
						} else {
							$(this).show();
							//if is the first visible I also show the function definition
							/*if(count == 0){
								console.log($(this).find('a'));
							}*/

							count++;
						}
					});

					// Update the count
					if(count > 0){
						$("#noResult").addClass('hide');
					}
					else{
						$("#noResult").removeClass('hide');
					}
					$("#filter-count").text(count);
					$(".count-hide").removeClass('hide');

				});
			}
		);

	});

	//Scroll slowly to the target
	$( function () {
		$('[data-zg-scrollTo="slowly"]').click(function () {
			var target = $(this).data('zg-target'),
				href = $(this).attr("href"),
				offsetInserted = $(this).data('zg-offset'),
				offset = $(target).offset().top;

			if( offsetInserted ){
				offset -= offsetInserted;
			}
			$('html, body').animate({scrollTop: offset}, 1000);
			window.location.hash = href;
		});
	});


	// Redirecting to the "Messages" tab in the My Acoount page when the user clicks on "View my messages"
	if ( SGL_JS_MANAGER === 'account' && window.location.hash === '#tickets' ) {
		$( '#tabs-account li a[href="#tickets"]' ).tab( 'show' );
	}


	// Fading out the bouncing arrow for the Home Page slider
	$( window ).scroll( function(){
		$(".arrow").css("opacity", 1 - $(window).scrollTop() / 250);
		//250 is fade pixels
	});

	$( '[data-zg-role="btn-search"]' ).click( function(){
		$( '#searchContainer').toggle( '200' );
	});


	// ===== Scroll to Top ====
	$( window ).scroll( function() {
		if ( $( this ).scrollTop() > 200) {        // If the page is scrolled more than 200px
			$( '#return-to-top' ).fadeIn( 200 );
		} else {
			$( '#return-to-top' ).fadeOut( 200 );
		}
	});
	$( '#return-to-top' ).click(function() {
		$( 'body,html' ).animate({
			scrollTop : 0
		}, 500);
	});

})( jQuery );

//PAYPAL DATALAYER
//DATALAYER PUSH
var statePayment = window.localStorage.getItem('state_payment');
var idPayment = window.localStorage.getItem('is_payment');
var pushGTMPaypalExpress = window.localStorage.getItem('pushGTMPaypalExpress');

var i = 0,
	intervalTime = 4000,  // 3 seconds
	limit = 40;						// 5 times - 15 seconds
function paymentCheck(){
	statePayment = window.localStorage.getItem('state_payment');
	idPayment = window.localStorage.getItem('is_payment');
	pushGTMPaypalExpress = window.localStorage.getItem('pushGTMPaypalExpress');
	if(idPayment != null){
		var looper = setInterval(

		function() {
				console.log(idPayment);
				var request = {
								orderId: idPayment
						},
						url = window.makeUrl({
								module: 'eshop',
								action: 'getStatusOrder'
						});

				$.getJSON(url, request, function (response) {
						//PUSH EVENT PURCHASE IF payment is done == 2
						idPayment = window.localStorage.getItem('is_payment');
						if(response.status_id==2 && idPayment != null){
							console.log('push datalayer');
							eval(pushGTMPaypalExpress);
							pushGTMPaypalExpress();
							clearInterval(looper);
							localStorage.removeItem('state_payment');
							localStorage.removeItem('is_payment');
							localStorage.removeItem('pushGTMPaypalExpress');
							if(i != 0){
								setTimeout(function(){
									location.reload();
								},1000);
							}
						}

				});

				if (i >= limit) {
						// * Stop checking *
						clearInterval(looper);
						//clear data in localstore
						localStorage.removeItem('state_payment');
						localStorage.removeItem('is_payment');
						localStorage.removeItem('pushGTMPaypalExpress');

				}

				i++;
		},

		intervalTime);
	}
}
$(document).ready(function() {	
	
	
	if(statePayment=='trying'){
		paymentCheck();
	}
});
//END PAYPAL DATALAYER